import callCmAPI from 'services/helpers/call-cm-api'
import { BannerT, WebApi2Response } from 'types/global'

/**
 * Fetches every non-deleted banner. Soft-deleted rows (`deleted_at`
 * is non-null) are filtered out server-side, so the list-page logic
 * here only ever sees live banners.
 */
export const getBanners = (): Promise<WebApi2Response<BannerT[]>> =>
  callCmAPI('/banner', {
    method: 'get',
  }).then(({ data }) => {
    return data
  })
